import './ChartDuration.scss'
import {CHART_DURATIONS, CHART_DURATION_ORDER, getChartDuration, setChartDuration} from "../../../ducks/chart-duck.js";
import {useDispatch, useSelector} from "react-redux";

export default () => {
    return (
        <div className='chart-duration'>
            <div className='buttons children-slide-down'>
                {CHART_DURATION_ORDER.map(id => <Duration key={id} id={id} />)}
            </div>
        </div>
    )
}

const Duration = ({id}) => {
    const dispatch = useDispatch()
    const current = useSelector(getChartDuration)
    const {isHiddenMobile, shortname} = CHART_DURATIONS[id]
    const durationId = id === 'ytd' ? 'ytd' : parseInt(id)
    return (
        <button
            className={`${current === durationId ? `is-selected` : ``} ${isHiddenMobile ? `hide-portrait` : ``}`}
            onClick={() => dispatch(setChartDuration(durationId))}
        >
            {shortname}
        </button>
    )
}